import { forwardRef } from 'react';
import { IconButton, Slide, colors } from '@mui/material';
import { Close } from '@mui/icons-material';
import { Dialog } from './Dialog';

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

export function FullScreenDialog(props) {
  const { children, actions = false, ...passThroughProps } = props;

  return (
    <Dialog
      open
      disableEscapeKeyDown
      fullScreen
      TransitionComponent={Transition}
      keepMounted
      actions={actions}
      sx={{
        top: 96,
        '& .MuiLoadingButton-loadingIndicator': {
          color: 'white',
        },

        '& .MuiDialogTitle-root': {
          bgcolor: colors.grey[800],
          color: colors.common.white,

          '& > button > svg': {
            color: colors.common.white,
          },
        },
      }}
      {...passThroughProps}
    >
      {props.onCancel ? (
        <IconButton
          sx={{ position: 'absolute', right: 8, top: 8 }}
          title="Close"
          onClick={props.onCancel}
        >
          <Close />
        </IconButton>
      ) : null}
      {children}
    </Dialog>
  );
}
